declare const __BUILD__: { version: string; sha: string; number: string; time: string };

/** Identity of the running web build (injected at build time). */
export const BUILD =
  typeof __BUILD__ !== 'undefined' ? __BUILD__ : { version: '0.0.0', sha: 'dev', number: 'local', time: new Date().toISOString() };

export function buildLabel(locale: 'ru' | 'en'): string {
  const d = new Date(BUILD.time);
  const date = d.toLocaleDateString(locale === 'ru' ? 'ru-RU' : 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  return `v${BUILD.version} · #${BUILD.number} · ${BUILD.sha} · ${date}`;
}
